import React, { useEffect, useReducer } from "react";
import { useLocation } from "react-router-dom";

import Table from "./partials/Table";
import FilterForm from "./partials/FilterForm";
import RewardCalcAutoToggle from "../../../components/RewardCalcAutoToggle";
import { parseQuerySimple } from "../../../helper/urlHelper";

export const Context = React.createContext(null);

const initialFilterData = {
  from: new Date(),
  period: "",
};

const reducer = (state, action) => {
  switch (action.type) {
    case "SUBMIT_FILTER":
      return {
        ...state,
        ...action.payload,
      };
    default:
      return {
        ...state,
      };
  }
};

export default () => {
  const location = useLocation();
  const initialQuery = parseQuerySimple(location.search);
  var [state, dispatch] = useReducer(reducer, {
    ...initialFilterData,
    period: initialQuery.period || "",
  });

  useEffect(() => {
    document.title = "Kết quả Keno";
  }, []);

  return (
    <Context.Provider
      value={{
        state,
        dispatch,
      }}
    >
      <RewardCalcAutoToggle gameId="keno" gameName="Keno" />

      <FilterForm />

      <br />

      <Table />
    </Context.Provider>
  );
};
